export const TOOTH_GUM_TYPE = {
  UPPER: "UPPER",
  LOWER: "LOWER",
};

export const TOOTH_NUMBER_KEY = "tn";

export const TOOTH_MATRIX_KEY = "tm";

export const TOOTH_STAGE_NUMBER_KEY = "tsn";

export const TOOTH_GUM_TYPE_KEY = "tgt";

export const TOOTH_PARTS_TYPE_KEY = "tpt";

export const TOOTH_RAW_TYPE_KEY = "trt";

export const TOOTH_PONTIC_NUM_KEY = "tpn";

export const TOOTH_PARTS_TYPE = {
  ATTACH: "ATTACH",
  BITESTOP: "BITESTOP",
  CUTOUT: "CUTOUT",
  HOOK: "HOOK",
  SLIT: "SLIT",
};

export const TOOTH_RAW_TYPE = {
  VISIBILITY: "VISIBILITY",
  IPR: "IPR",
};

export const FILE_TYPE = {
  ZIP: "ZIP",
};
